export default __webpack_public_path__ + "locales/ru/DowngradePlanDialog.json?hash=eb8ea5f0359b42ed38b6e3dfd135d81e";